import FakeApp from 'components/FakeApp';
import Layout from 'components/Trials/layout/Layout';

const ModalWrapper = ({
  children,
  primaryCta,
  onPrimaryCtaClick,
  progress,
}) => {
  return (
    <>
      <FakeApp />
      <Layout
        primaryCta={primaryCta}
        progress={progress}
        onPrimaryCtaClick={onPrimaryCtaClick}
      >
        {children}
      </Layout>
    </>
  );
};

export default ModalWrapper;
